import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + '/plat/admin/track/export/';

function baseApi() {

    function createExportTask(data) {
        return Post(baseUrl + 'createExportTask', data);
    }

    return {
        createExportTask
    };
}

export const exportTrackDataApi = baseApi();
